import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from 'src/app/login/login.component.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../shared-modules/components/confirm-dialog/confirm-dialog.component';
import { AppService } from '../shared-modules/services/shared.service';
import { Country } from '../user-management/country';
import { DialogBodyComponent } from '../user-management/dialog-body/dialog-body.component';
import { ContactUsAdminService } from './contact-us-admin.service';


// export interface DummyData {
//   country_code: string;
//   country_name: string;
//   contact_name: string;
//   contact_image: any;
//   designation: string;
//   phone_number: string;
//   email_id: string;
// }

@Component({
  selector: 'app-contact-us-admin',
  templateUrl: './contact-us-admin.component.html',
  styleUrls: ['./contact-us-admin.component.css']
})


export class ContactUsAdminComponent implements OnInit, OnDestroy {
  //selectedItem: String = 'Contact Us';
  navbarOpen = false;
  //countrySearch: any;
  //Countries = [];
  countryList: Country[] = [];
  userInfo: any;
  name: String;
  isLoggedInUserAdmin: boolean;
  user: any;
  image: string | ArrayBuffer;
  validFileExtensionsForUpload: string[] = ['png', 'jpg', 'jpeg'];
  imageUrl: any = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAACWCAYAAADJ//pSAAAABHNCSVQICAgIfAhkiAAAIABJREFUeF7tXQl4VEW2/uve3rIvGCAJhAQIawDZ9yfgIIKAZOkoZEF8LqO+5zrjoM4ojj511HGZz3Ef1HQAyYqiLCogyiKCbAECAbIAIRtZyNrp7nvrfXVDY4CEdNLrbVLfly+EruWcU3+fqjqn6hyC7gJo0/xAmx8FpUMUHBkLQnpTwAMAoRSk5TflKKR//14oBcdxAgBWixL2m8LE86gwGOkZgO6Eif8RXyVs7hbz1cK7ESQSvUoLji4jhI4gHOlBBaqhBESj5AQPNU96+XpyQb5q+HupwHMceB7S70AvFXr4qKFWcpKUjCYRRoGioKIegkAhiBQmkf0Wcaa8ARebDGJlfTNtNohEoJTjCDEApF6kwimIZBv0pnewYVnpjSByM49XflPdkfPY1UtBaQLHYyylor+C58SQAE9hQG9vdZ9AT/Tp4QmNirc754XlDbhQp0d+Wb0pv7yONjYLSo7AIAKnQelmNBrewYb7iuxOiBMHcC+wadN4mEyzwYuP8QRTRJH6KBW8EBqooaP791AOCfF1CLAsnU8GwN/yK4XTZbVivZ6BjxgopUWUcv8Cp9QhPf6ipX3JoZ6bgI0SxKa+zRHcJQK9/b1UhkkDb1KN6R/oUuDqCBAMfNuPlRoLyxs4SqlJpGQ7RO4lZC/Z0VFbOXwub7BpVz1AqPgcKPqqVbwwbWhPfsKAHsQRy6K9JzfnTA125pYbSmqalIRwtaJIN6NJ/7Scl1pZgo3TrvoMoEsIgeLm8ADcMqw35++ltPf8O63//flV2Hq0xFjXYFIoFOSQscEYj2+WnXQaQV0cWD5gY/sx0bCaEBrrqebF228OVY4KD+gi2/JsVnGxGet/O2ssqmhQAPQsBVmKjKQf5cKN64NtQUoE1GQNoZgQ4K0y3jU1QhUcoJGLfO1Cp94gYPPB86YDhVUcKMpEYDkyklLsMpgNO3VtsMWkbAIht/XwUZmWTB+gDPJV2ZB19+hqw/5icc/JCwQgFVQ0aZF1z0+uyplrgi1W9yQheNVDxXOJ/9VfwWxh3eX6Evjix3xTfmkdD4LdNOP0dGCF6Goycy2wRa+ezPPiOnC4ae7NIdyEyJtcTV4uTc/FRiNWbj1tqmloZu6115CZ/FdXIthFwEaJ4q5VO0SRTooK8ydxk/q5CF2uNFWW03LifB3SdhWIIkW9YDItcJWl1fmTGpM6lePpFi+NQnnPjEiue19mOag6qpm15wwOFVZTAvqZmJH83x3Vt/fnTgUbF6v7lAL3jooIIDETw+zN6w3Z/8mSeqzZUUApUC7U0XHYmHjOWYJwDtgWrgnhNcJuAtJ38bQIEhns7Sz+b4hxmank8x9PiyU1jaAC7kFWss4ZjDsebLGpiYTQz4N81eS+WyM5d3AtOWPiujLmz7nl+OFwCXiO7DSlJU7rSh/WtHEo2LjYlP9QQpb9YWQwmT60pzV0d7ftogTKqvX4z7aTosFEq8QG1QhsiHfYnTqHgY3EpW4mwOylM/uTiJ7dy2YXsWKzZv/acFyoqm82ino6DOuTC2zW8XU6cgjYOK2uiCOk76N3DCH+nt1eAEdMrCVjpPyYT/PL6gVRFBKRtXStJW2sqWNfsN25si+vVh9ScvB/9I6hxFujsIbW7rZ2kMD6feew91QlBRT3IXPxSjsMcblL+4Et+otBnII74uuhUjy5YKj9xrGndG6QvrfmlGL70XJKqZiKrORke7FtHxAs/HQgp9bk9vb34P94W6R9xrCXRG7Qfg8U1iB7TxGUHPelMS1hsT3EYHsgzPu0H+elyfPzUCqf6NZo9pgzu/V5sKgGWb8UApQ8hcykt2w9kG3BtmD1TZxGOOerUameXNi9dNp6shzR395TVVi/7ywAxX/beg9nQ7Ct4BTaAeUeKmXgnxcNs2G/jhBx9xitJfD9oRL8nFsGgEtCZmKqraRjM1Dw8boSNc/3Wh4TZbM+bcVkdz+dlwA7pe47VUmpgLuxLimt8z1c28ImwFDGrzpOgUFsj+bTbd6wxby4RB9Zv5zBoaIqkTZjoC0Mv1aDTRGb+q5A6KOPzx+KAC/3MdiW1uhRWF4PvVFAQXm9NPkl1Y3QG3+/ANvbXwMPlQL+nkoEeKsR3tML4UHu5R15f1MevVDXXGtKS/C39htgHdjuXDUHCmGTdko4RoRZTYu1vFjd/njxReSeu4jc4ovwVCnAngmGBXnj9tEhUt8zhvZErwAWb6alrN3VEi0hr7gW+eX1+CWvHMfP14G540ZHBMLVXuB3VUAvZ+RQkWK/KS1hXFf7YO26Dra5qX04bxSMCg9QRE/oaw0NTm3Lrt/8cvIC9udXwlujhHZKGO6ZMRAj+3X9y/P+pjxk/lKEXXkVGBrqh9ERPSStJ9dSVd+Md789Dgq8iIykFV3lo8tgYwcCH42ql1y9A2aQ7TpRjimDgvD2svFWAaytCSirbsLHP5zCO9/mws9LhbmjQ8GWXjmWvacqW0wiBkUU1i852hUeugQ2Eqf7hue4eU/fOUyWoQ7YMrlxfzHGRATaBWRtTcRL6Tl4JTtHWl5nDu8tqxgkZn6+3FmI48UXjWJ+oxd+e9DYWcB1HmwxqXcRgjXJM/uTAb3ktRlm2mzjgWJU1DbjzaVjcdeUfp2Vl1X1mab74ye/4sejpVgyvb8stdzrXx0VmwxivpCWENlZYXQabFx8atPIMH+N3N4MsNPl6p/zMWN4b3x4/4QrNvqdFZq19dme7qmUfdKyyjSdnEptkxH//PoYqAlLsC5pTWdo7xTYuNhUnVJFljwXM6Il/KJMCgPayq0n8Wz0CPxNO8IlqGZabtzyjWBRLqNl9tjnh8Ol2HG8rFmE2gvp8SzMq0XFcrDFrh5CIBy7f3YkkdMLdQa0NT8XIONPt2DWiF4WCcVRleQMuNfWHRGamk0baUbyAkvlZTHYeG3qufCeXsFLZwyQjVZzZaCZJ0iugCuuasLH3+VRKiqHI/vuXEsAZxnYYlNf5Aj+tjx6uGxOn+ww8NY3x/DP5HF4+PZBlsjCaXXMgBvRzx+TBwU5jY7ODpyyPV8sKK2/IGQkWrRkdAw2bZqKoLlx7ug+/KTIHp2lx2n13998AounheOtpVYZvR1G/+GiGkx8ZgPunRUpm1Mq+0K/ln2UiiJ5GVkJz3ckrI7BFqNb46nhtcujo+wfUrsjai38fOuRUtTrjdj72jwLW7hGNXZKfW7NATw8Z7Bs7HBbckrZdaRmMT3Rg6WLuJ4krw+2GdsUXFBxU9zkfoqovn6uMSMdUGE+eRb+O9qp5o2uCuvWFd+DufpnRfXuahcOb/di2mEqiOI/kJn8TNfBFpv6roeae+QZGWm1z7adxqIJfWSzfF49OWz/Fv5INh6eMwRyiRO85XAJfj5RoRfTmHZrv1xHs1HCaVfpYyaGqaxxSjvya8ZCu6/79QwqP4935LA2H2vZv3fjYEEVYibJJ9iOpN0oeR4ZCS+3J5D2wRaX+qZGSR5/NmaEbPZqTKstmzHAZQy3XUWhHLUbiyGy40RFg5iW2K4Ps12wcVqd/o4xfdTjB8rjBMr2al/uKJC9VjMDVI7abUXaIVEUyb3ITPyirS9a22CL1T2p4Mkbz2tHysaAu2F/MYaE+uGzRyZ3VaG4VDuzKeTZGNdwr1kinPX7ztHfTldWiBlJbdrd2gQbp009d3N4QMiiCX07No1YQoUD6rySlYM9r86z+Z00B5De7hDjl29AZLCvdAFTDqWmwYi31x+jlFP7Ij2+5S59q3ItmMZ+pCThns1PLBhG5HIaYkvo13vP4uxHMXKYE4tpfPKLfdiWUyarg8I73+SaquoM65GVdM1kXAu2WN1qb41C+/Si4bKJArM7rwJqBY/sp2+xeCLlUHFrThli3/wRTy4YJgdyJRp3n6jA5sPn9WJa0jVmkGvAxsXrLs6OCvGdOlQ+PrrVOwrwv7cPcXkfaFcQ47FkNZ6cP0w2HgXG4wtrD7EYvrOuTnV0JdjidDMIsPWZ6CjZONwZc8wPuurR6S53hagr4Lq6zdDHvsKUwb1k9WDmo+9PCuerm36j6YkT29+zxaX82Nvfc+rDcwbJZgllzDy/9hBoeqIt5tbl+mDuK7WKl9VtkKKKBnZZVaQZyVfYaK/QbJxW1zR/bF/NuAHyuqrszmBj9rbCinpZ+UrZN/bFtMOiYCIxyE74yvwN/h1sczeo4VWp//tdo1zu2309gtz1JGrmWa5ge2/jCaG8tmkHMpJnXAu2Rbp/e3jwDzwTEyWrJZT5Q3edKEPuu3fK6ktiKbFyBRu75vVTblmtmJZ02Uh4WbORON3pISF+EYunh8vGkMsmrBtslsLWsfXYxcpXso5QZJ5WmDMEtgJbqvHuaeGKoaG+jqXKBqN179lsIEQ7dPFSRo5gFPEw0hM+Zt23gG3hfwYTlSr3xbtGyUqrmeXjzmCLfn07ahoNsjsgsLn56PuTpvPVjXtoepKUTaYFXNEpH/t4q5b9eeEwWe3XzGB7a/0xbP/7HLfyi5p5k6OdzUz77rwL2HywWC+mt3gTJLBx2lV5g4J9IpdMD7eDMrV/lyu3nsJriWMcHk7B/pwBPZalSVGV5OKnbi0Tad+WfQQgajXS4w2XwKZjr6c8Jsro9VRrptztepGZNzleM7r6Cyi5rppNE7F+2V4JbESrE5bNGMjJNYaYu55IWeSj1TsLsGRahCOUqF3GeCUrR9AbhDfYYxgCbZo3aHOd3Iy5V0uGHRJKP46V5Yuq9maZuapYXDe5BZ9pzc+/N50Qyi62GHcJtKse4An94AUZ3cpta3JYsGEWWclVAsdYqybYO4SIR7LxhMxufFzN96qfC3CypP64mJ4wlCBGt9JTwy1dHi2vyERXM8UC/O3ILceZD93jAqU7LKFsjlgI2U0HipvE9CRPgrjUA+FBniPvnTVQNu8N2tMazATy4YOT3OJUOuzx9dJND7nuo81zdL66CR9tzqM0M4kjvDb1/NgBPYLnjw21VvM7vf2BgiocL67FsXcsjuLkdJrbIoBFIV+euh/3zhrokvR1lii2n0YD8SOcVtd4++hQj0mRN3W2D5es7w7aLeyPWZg9MkT2Ws0MEAlsJkUEA5t+/ri+6nH95XWHrT2ky33vxh65ZO856zZajc3TirWHqSiQaMJpUwyLJvRTsgQT7lLYm4RJkUGye0PKjLgznv8Oy2bJ02PQHn5eyjgsGgXyAuHidMa4yeGKqDB5vE205AthDgT4+f9Mlc1hgZk6xj+zEeMG9JC1Xa2t+Xk587BoMOJlQuJ04oO3DSIhrdLkWDKhrl6HeRXW7MhHgUxCZ9364veoqjPI6o2opRh4JStH1BuE1wnidPSvsSOgUsje8nEN7+x0uu90Jfa+OtelPQsMaMfO1uLeWQNk9WTPUrC9mp0jNjXT9ySwyd1VdT2m2QPmI2dqXBZwT32+H2yP6a5AY3Pz7rfHhcp6/Va3Bxtj1gy4zx+Z6lJvS91do5mVwL82HBcv1Ol/lMD2bEwUNErZhGGzVHtfUY8tqZsOFONNF4gezg4DM1/8ARQUMRPC3HLpbC38y8soidWJckuk0SW0ATCnFJoZ1Rsf3OeclELMO7DsvZ2YOChIlle9uyL7/8vKEZvZAYGZPqInhSlG9XMfO9v1BMLMIuyy5ZnKBrx0180Oiw/CbGj3fbAbJ0tqZZskrStAY20k04eJ2dm0uub54/qq3MWDYKlAmGmEgS7AW4Ul0yPw19goS5t2qh4D2ROf78WuExWYdANps9ZC+nvGIdFkwp/dzjfaKSQAUopuFuaJZZu7c3xfPH7HUKsfzrA92SdbT0sx43LOVEsgYwl0NSr33he3J/sVaw9R0cDPY2Crv3VEiNd0GYXI6iygLKnP9nMsdTfLE+/joZQs+X8YGYwhIX4dnmAZuLbnlmPTwfP4Je+CBOAhoS0RI9nPjQoys9wlRzwxBRNOm5o/bkCPCHe4YmQJqCypw4BXUF6HgvJ61NQbUXqxCYHeKvTyuzK+Hcsic7ayERolh97+HtJPRC9vRAR53/AAay3nFrCpFezy5J4BvbzGySnbniWAsXUdFi+2psFwRbdMY8k157ut5dNef1Kc3W+OiTQjiSeI1r3h6ck/sXyRfHJTOUpQ3eNYL4Hf8quwft+ZRjE92YsgZs0ShVLQPR8nnzD01ouguwdHSeDLHUX0eHHtMTEjIYo95eNBm03u7B91lGC7x7lWAh9szhNKapq2ICNpTssj5bhU0/1/GMjLKR1398TKQwKvZh0Rmgzi/yEz8YVL4RdSGhaO6+c5pv+N4UWQxzS5B5VS+AUjGYWvEnPMgWVyh4T4Dr57Wj9Zhsxyj2lxPy4uB5bJSGpZQSUWo1M+9vVR3vOnBcOV7sdyN0fOksCvpyqxYf+5K0NmQZs2mNBm2QYDdJYwu8e9vgRWbj0lFlbU70VG8qTfNVvLIcGY+F8Rishgn24ZdkvAJhJ4OTNHMBjxODIT3rsKbLrTw/v4R8RPda99m2T5b2xGabUeeqNwWYjV9c0I8FZLHoBwO7uXWB4DdsukyWAC28ewcc2Fjc88EYwGdyqX9msUGYk8QOgVYENc6pteav6xv8goQVpbk8Mc6S2+zXqUVDfCU6VATz81hoT6w99LdblJ/57eyC+vx5Gz1dIbBfbZsD7+0iv03n4eVvk22filNU3IPXsRBRV1uMlHIzn2I3p5IcBTLY1rLmz8+iYjjp+vk4Af7O+B4ABPKXeqHKNNmvn6+Vg5thwtaTs0PbRpgaDNlXI07jKA5Z67KN22iArzR1TfANw+OgQzhva0+FUVu0G76QC7tVEuTby/p1LSQBE9WzROewFezD5TpilrGo0SyPsEemJQsA9mDO+NB/4w0GIaWBa+b/afxaGCauzKq5BAx2KzDQnxtQr8ztCYH3x30lRS3bCz7aQbUmxdXXP0hDDVKBm8jmdqmoVjYteCvDVKaKeE4S8Lh1s8sR1NAJv4ijq9BEBWGAjbKiEBnggL8gbTlINCfW36KPr9TXnI/KVIAh67qjQzKlg22u7F9EOiIHJ3IyMh3Sy3K+xqRJvyU2iA15QHZke67C0/M8h2nSiXLiS+vWy81ZcdOwKesz9n9+U+/uEU3vk2F/2CvFwedOeqmvDJ93kizUhUmPdrV+7Z2F8ungKSXUzceqTkhgHZ1SBnoFu++iC+3Fkgabq5o0Ndcnn95IeTwrnKxgM0I2l8ax6u8Rjw2tS620YFe08e7DrJbZk2Y5F96vRGfPvsLLfXZB1p0tagi54Y5nI55CUXlYncgXWJG68LNsTqVvt6KuP/tHCYSyylbNOfvecM7p4aIbuoRB2BxtrP2aHm4Y/3YHCoL2YO7+0SWm73iQvYfKi4UUxP8rqav2t9odo0b0Kba5+YP4w4++jNQMYSpaY/dUuH7wCsnTi5tmdabsm7O3Cs+CLunTnQ6YB755tcU1WdYT2ykq4Jbtym453XphaP7BcQHD2xr9Mc8wxoFbXN2PeaaweFcRWQsoDPr2Tn4N5ZkU67qn7pCjiltdQH3yU3dKzZWI1Y3ZMKnrzxvBPC1bP92ZqdhYgI8sLqx6bZzJThKqCwJx3OBtz6fWfx2+nqMjEjsXdbfLaruVgK73lj+mgmDOxhT/lc0TcD2sptpzAs1A9bVsx22LjuNBDbxz300R4snh7hcA23Iv2QKLKUjxlJH3UKbIhNfVGj4p591oGZldnSGeCl6gaalehngLvnvZ0OXVJ/OFyCn3PLGmhGcrtO3uvuybi4FH3c5HA1cwHZu7A0z6dK6nD2I/dImmFveXXUP1tS3//uhMMODZLHQBCfQ+bS19qj7foHgLjUNz1V/GPLo4fbNQ8pC2e1/WgZjr29oHuP1hGKOvE5S4x7qKgay2YO6ESrzleV8sEfK2sQ05Oue3Wlg9MmZS/m9fFTIlTD+tgnnTc7wXy29RQy/tRt3uj8NHfcYvzyDZLveFZUm3v2jjuwoIYlWo1107FpQ7p6pHjsL4vsk2X5s22nccuwXt0GWwsmtStVzDlLH54zxC5OfLYibT1S0kgzkq8x4lpm+riqFhen088f20c9zsYnU+YdYPeeuvdpXYGR5W1YIo91v56z+XLKrAf/+OqIKIj4GzKSXumIoo41m2R3S32O5+nf/3JnFGeriDzmXAXfPnNrt3ego1mywecs13xELx8p+ZqtyqqfCoSTJXWlYkZiH0v6tAxsAHhtan7/Xt5hSbf0t4nPVO5pfywRrivVYadTZsO0VfK18ppmvLf5OIWheRC+vu+UJbxaDDYs/HQgUarzHpozmPQO0FjS93XrSAbcracxrK8vtrzQbcC1WqDX6YBdBI17c7tNDb2vrzsq1DeZvm7LB9o108fVraJ1Og8Pfskz0VE2ydDRDTh7Qqylb3sAjR0Kth0tvfwe1FIuLNdsl3pkbqwx/QM1C8f1tXSMbg1nE0l1vhN7AI0piFezc0BFcieykr7uDFWdBhuiV91JeJq9bNYAEh7U4WnXIlq6NZxFYupUJQa0+a9uwSIbX6785/pcsa7RlCdmJAztFEEW2dna6JHEpmxSKPjb/rxwGLHl6bR7D9fZ6Wu7Pnso86eUfbh9dKhNM/yxxzeHiy6aaEGDJ3570NhZajuv2S6NwGtTywJ9VDf979whNtm/sW6Zhsv69Qwa9CaXzTXVWQE7ur69rhkdPXcRa3cWAAaMx9fJ+7rCV5fBhgUpEURNTk6KDOLnjgnpytjttmH5CYqrGuFquaZsyqQdOjPnwmJ5HWx5y5qF7X9rfS4VRfomMpOe7irpXQcbGzF29SIQU3bC9AEYHGLbGCHmXFOfyShBbVcnwdp29s6F9Vr2EVFvpLlieoJVmUmsAxt72BybqgOHhKcWDiM+GtteDmFhDFZuPSk9WXNWrilrgWDv9tKjl0/2YFCwL+aNCbX5cJ98f5IWVzc2iumnfYEVojUDWA02NjinTT3LcyTUlgcGM1Ot93Hdy+rvU8202UOf/optR0oRM7Ffu+EhrAHH+n3nWHJgkTYpR+Hbu49Y0xdraxOwYe4GNedVWaJRK/yWLxpuswNDa+bMT/oWT4vAyocnW8u3rNu31mbs6pCtLAKthfLD4VL8lFsKUOVDyFz8oS0EZhuwMUpaAFfu46H0YUuqLYi7uo/WWu6N5LE2jathD3pt3acjtBmjed/pKinvFih5AlmJ79iKD9uC4rYUL+LHVfl7KJVPLBhq275bccy03Mb9xVKUnxfiR7o96BjInllzEF/uKMCo8EDpIqQ9tBkT8f6Cany15wyojYFmu2W0NfQXfT6AKBTHA71V/GN3DLEb4NiQ7MTK9ixj+gfi7XvcL8BMa5ANlhK22TeK0aGiGmTuLgQI9ywyEl+1lUYz92MfMGjTBnPUcCQ40EPx4OxIW9N8TX/sDvwveRWYMjgIz8WMlP39OAay17/KxefbTyGsh5fdQSZptMJqrPulCBzFKjErOdEek2YfsDFKo78YxCm4Iz4apcJee7jWAmH7ORbH7GBBlZTC8YHZg3D/rAGyekDDNv4ff5+HrUfKcHO/AIeAjMnwu0Ml2JFbDg5IFTOTkuwBNPsso60pnf9FGO/JH1ZwnO//zB1M/DwdE/me7enYEltUXg8WjcmVtV1rLSaKVKJ3dHig3fZkVwMpfXcRcs7UUFDuEWQmfGAvoNkfbBLllPDaVecABD80ZxDp6Wf9xUtLBcK03YHCKilTMscR3BweIAXSc7bGS2MhVQ+eB3vYW1GrlxLoThnS0+Ev2D/8Lg8l1U0CFUkCshLXWirXrtaz3zJ6FUV8fMrPokimaaeEI6qvX1fp7XI79mQwt7hGinlbWF6PIF+NlCn59ptDpGDJI/vZ5yG2OctyXkmdZE44cqYafp5qyQhrDhjdZaasaPjm18dovd5oEk1iFLKX5lnRlcVNHQY2RhEXq1srgsZPGtwT80bb1nlvMceXKrJQ8fnldRLwWNJaFnyZRXMMDtCgX5C3BEJzYdG+Z43o1eYQ7KkcCyBtLnvyKqUI4ceLa1FYXocmowh278/fUyVlWXZ2Gu8zFY34Yns+FalYKzQKI/HN0jOdlV1X6zsUbBKR0auXEV741M9TRe6fHWlzf2pXBcHaMQBWNzSjusEggdBc9AZRSt3dVjGn7DZ/xlJ3MxtY/54+Urh7W96+sIY31tbsFVCr+J3Nq5dMbx3v1tq+LWnveLAxquZ92k/l7bFboLS3dmo4GRZqn9f2lgjgRqjD9q6fbDlJL9Q2Uyrw9yF7yWfO4Ns5YLvEKa9NTREpTRze15/ET+nnDP7dfky2nK/dVUgJSImpjk7ExkR2WHNKcSrYJI5jUqdyHN3ioVYo7505kAvy+z3VjlMk4kaDpu8+ww4klCMkVUhPTHY2a84H2yUJKOJX7RJEcdKIsEDETXZeeFVnT4gtxj9xvg5puwqpIIqNokDmICtxpy36tbYPlwGbxMiitAkKpSELHILnj+nLdWd27tz0suvbn207LVTXGZh98zkxI+kfnevBvrVdC2xmXmNTHuU47g0PFadIvmUgx8wR3aV9CbADQMaeM/RUSS0l4HYJ6QnTXVFergm2S5IicSnrALKwh6+axk7sx4UGeriiDJ1K09d7z2F/QRUlhJYJBvWdWBf/q1MJus7gLg02ie6Fa0KUHmKaSRQn+3uqGOj4sCBPV5WnQ+himuzb/edpTlEVlDxX0mzkHkPW4gyHDG7FIK4PtlbMcbE6HSVYrFbxmDc6lGe+zhupVFxsxvrfzglFFfUcR0iRQPkEZCzeJRcZyApsl4Uak/Ip4Ugix0E5YUAQuynBuZKl3taTv/dUJX7KLTPWNhoVIGQPbdDfjQ33Fdl6HHv3J0+wmaUSp7uPAC9ToKdGyQtTBgdxkyJvslnAQnsL/3r9Hy6qxq7j5YaSGj27l6WnIr6FSfEYvl7ckgBVhkXeYLsscEoQo3uLcFw8QIO9NUrTmP6ByqmDgxx2L8wWc9/uUX8uAAABZklEQVQSILHMWFzVxFMKIwW2Q+BXIHvJblv07+w+3ARsrcQ4Py0UKv3LhCMLKBCo4IgY5KsRhvbxVY2O6AFHXeC0ZGL3F1Sxi4tCcWUj1RsFBQExUOAgBPFpZCdvt6QPOdVxP7C1lv7Yj5QI93oARNQSYBQF8eM4UF+NSgwO8FT06eEh5YDv08O+p9vaRqOUNa+qrpnFMBHLLuqpwSTyErioWAhKtoFXv430+BNyAk9naXVvsLUljbhVCSBiIgEiCdBbpGBIIxwhVMlzoo+nAj28NVyAl5KolDzUCg4qJcf+Dz191dKyrFJwaGg24WKDAcXVTTCaROiNAgwmUfoprmwUapuMVG8SOMEkciAEHIEeQINIyWlQ8hOaDP/EhmWlnZ0wOde/8cDW3mzF6B4A4SJBxPGgCCWE3kQAHoSwgNVsD6Wg7O8rC+UIWJwygf1QCoESNICSQkAsBaU/oUlce6OBqj0R/z/kZYEwLC531AAAAABJRU5ErkJggg==';
  editFile: boolean = true;
  removeUpload: boolean = false;
  isImageUploaded: boolean;countryCode: any;
;
  isMyProfile: boolean;
  addUserForm: FormGroup;
  // public dataSource = new MatTableDataSource<>();
  emailId: string;
  displayTable: boolean = true;
  submitted = false;
  // dataSource: any;
  public dataSource = new MatTableDataSource();

  listCountries: Country[] = [];
  selectedCountry: String = '';
  countryCodeList: number[] = [358, 46, 47, 45, 91];
  yearList: number[] = [];
  phoneNumberWithCountryCode : string;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  public displayedColumns = ['Contact_Name', 'Designation', 'Phone_Number', 'Email_Id', 'Country_Name', 'edit', 'delete'];
  getContactData: any;
  getContactDataCopy: any;
  loggedInUserName: string;
  getCountryData: any;
  getCountryDataCopy: any;

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;




  constructor(private contactUsAdminService: ContactUsAdminService,
    private sharedService: AppService, private router: Router, private formBuilder: FormBuilder,
    private loginService: LoginService,
    private cd: ChangeDetectorRef,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private media: MediaMatcher) {
    this.userInfo = this.sharedService.getLoginResponse();
    this.name = (this.userInfo ? (this.userInfo.FirstName + " " + this.userInfo.LastName) : '');
    this.isLoggedInUserAdmin = (this.userInfo ? (this.userInfo.RoleID === "PA" || this.userInfo.RoleID === "A") : false);
    this.loggedInUserName = (this.userInfo ? (this.userInfo.FirstName + " " + this.userInfo.LastName) : '');
    this.countryCode = this.userInfo.CountryCode;
    this.user = [];
    const navigation = this.router.getCurrentNavigation();

    if (navigation) {
      const state = navigation.extras.state as {
        emailId: string,
        isMyProfile: boolean
      };
      if (state && state.emailId) {
        this.emailId = state.emailId;
        this.isMyProfile = state.isMyProfile;
        //this.updateIsMyProfile(this.isMyProfile);
      }
    }
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);



  }


  ngOnInit() {
    this.buildForm();
    //this.countryList={no:'Norway',dk:'Denmark',se:'Sweden',fi:'Finland'};
    //this.countrySearch='fi';
    //this.getDummydata(); 

    this.getContactData = [];
    this.getContactDataCopy = this.getContactData;
    this.getCountries();
    this.getContactUs();

    this.translate.get(['HOME.itemsPerPageLabel'])
                .subscribe(data => {
                  this.paginator._intl.itemsPerPageLabel = data['HOME.itemsPerPageLabel'];
                });
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }

  buildForm() {
    this.addUserForm = this.formBuilder.group({
      Contact_Name: ['', Validators.required],
      Designation: ['', Validators.required],
      Phone_Number: ['', [Validators.required]],
      Email_Id: ['', [Validators.required, Validators.email]],
      Country_Code: ['', Validators.required],
      Contact_ID: [''],
      Photo: [''],
      PrimaryContactCountryCode: ['', Validators.required],
      UpdatedBy: [''],
      CreatedBy: [''],
      UpdatedOn: [''],
      CreatedOn: [''],
    });
  }

  // convenience getter for easy access to form fields
	get fields() {
		return this.addUserForm.controls;
	}

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  // showSelectedMenuItem(itemName: String) {
  //   this.selectedItem = itemName;
  // }

  // getDummydata() {
  //   const test_data: DummyData[] = [
  //     {country_code: 'FIN', country_name: 'Finland', contact_name: 'Test1',contact_image: '', designation: 'SSE', phone_number:'9896398745', email_id:'test1@nynas.com' },
  //     {country_code: 'FIN', country_name: 'Finland', contact_name: 'Test2',contact_image: '', designation: 'TL', phone_number:'9896398746', email_id:'test2@nynas.com' }
  //   ];

  //   this.displayTable = true;
  //   // this.dataSource = new MatTableDataSource(test_data);

  //   this.dataSource.data = test_data;

  //   console.log(test_data, "dummy data");
  //   this.dataSource.sort = this.sort;
  //   this.displayTable = true;
  //   this.dataSource.paginator = this.paginator;
  // }

  getContactUs() {

    // this.isRequestCompleted = false;
    this.contactUsAdminService.getContactUs(this.countryCode)
      .subscribe(
        res => {
          if (res["ResponseCode"] == 200) {

            if (res && res['ContactDetails'] && res['ContactDetails'].length) {
              var contactUsList = [];
              for (var contactUs of res['ContactDetails']) {
                contactUsList.push(contactUs);
              }
            }

            this.getContactData = contactUsList;
            this.getContactDataCopy = this.getContactData;
            //this.excelData=this.deliveryGuideDataCopy;
            this.dataSource.data = this.getContactDataCopy;
            //console.log(this.dataSource);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.displayTable = true;
          } else {
            //console.log("response is: ", res['RequestStatus']);
            this.displayTable = false;
          }
        }
        // this.isRequestCompleted = true;
      );
  }

  getCountries() {
    this.contactUsAdminService.getCountries().subscribe(
      res => {
        if (res["ResponseCode"] == 200) {
          // this.listCountries = res['Countries'];

          if (res['Countries'] && res['Countries'] && res['Countries'].length) {
            /* for (var country of results[1].Countries) {
              this.countryList.push(new Country(country["CountryID"], country["CountryName"], 91));
            } */
            res['Countries'].forEach((country, index) => {
              var countryCode: number = 0;
              if (country["CountryID"] === 'FIN') {
                countryCode = 358;
              } else if (country["CountryID"] === 'SWE') {
                countryCode = 46;
              } else if (country["CountryID"] === 'NOR') {
                countryCode = 47;
              } else if (country["CountryID"] === 'EST') {
                countryCode = 372;
              } else if (country["CountryID"] === 'DNK') {
                countryCode = 45;
              } else if (country["CountryID"] === 'GBR') {
                countryCode = 44;
              }
              this.listCountries.push(new Country(country["CountryID"], country["CountryName"], countryCode));
              // this.listCountries.push(new Country(country["CountryID"], country["CountryName"], (this.countryCodeList[index] ? +this.countryCodeList[index] : 0)));
            });
          }

          //console.log(this.listCountries);

        } else {
          //console.log("response is: ", res['RequestStatus']);

        }
      }
      // this.isRequestCompleted = true;
    );

  }




  expandConfiguration() {

  }


  readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.image = myReader.result;
    }
    myReader.readAsDataURL(file);
  }

  onSelectFile($event): void {
    this.readThis($event.target);

    // if (event.target.files && event.target.files[0]) {
    //   var reader = new FileReader();

    //   reader.readAsDataURL(event.target.files[0]); 

    //   reader.onload = (event) => { 
    //    this.url = event.target.result; 
    //   }
    // }
  }

  validateFile(file: any): boolean {
    let extension: string;
    if (file) {
      var regex = /(?:\.([^.]+))?$/;
      extension = regex.exec(file.name)[1];
    }
    return (this.validFileExtensionsForUpload.includes(extension));
  }

  uploadFile(event) {
    let reader = new FileReader(); // HTML5 FileReader API
    let file = event.target.files[0];
    if (this.validateFile(file)) {
      if (event.target.files && event.target.files[0]) {
        reader.readAsDataURL(file);
        reader.onload = () => {
          var test: string = reader.result.toString(),
            encodedImage = test ? test.substr(test.indexOf(',') + 1) : '';
          this.imageUrl = reader.result;
          this.addUserForm.patchValue({
            Photo: encodedImage
          });
          this.editFile = false;
          this.removeUpload = true;
          this.isImageUploaded = true;
        }
        // ChangeDetectorRef since file is loading outside the zone
        this.cd.markForCheck();
      }
    } else {
      this.openSaveUserDialog('Invalid file type', 'Only .png, .jpg, .jpeg file extensions are allowed for upload', false,'contact-us-message');
    }

  }

  openSaveUserDialog(headerTitle: string, message: string, isSuccess: boolean,headerNumber:string) {
    this.dialog.open(DialogBodyComponent, {
      data: {
        header: headerTitle,
        message: message ? message : ' ',
        buttonText: {
          ok: 'Ok'
        },
        isSuccess: isSuccess,
        headerNumber:headerNumber
      },
			height: '37%',
			width: (this.mobileQuery.matches ? '50%' : '22%'),
    });
  }

  saveStatusDialog(response: any) {
    if (response) {
      if (response['ResponseCode'] === '200' && response['ResponseStatus'] && response['ResponseStatus'].toUpperCase() === 'SUCCESS') {
        this.openSaveUserDialog('Contact Details Saved Successfully', null, true,'contact-detail-success');
      } else if (response['ResponseStatus'] && response['ResponseStatus'].toUpperCase() === 'ERROR') {
        this.openSaveUserDialog('Failed to save contact details', (response['Description'] ? response['Description'] : null), false,'contact-detail-fail');
      } else {
        this.openSaveUserDialog('Failed to save contact details', null, false,'contact-detail-fail');
      }
    } else {
      this.openSaveUserDialog('Failed to save contact details', null, false,'contact-detail-fail');
    }
  }

  deleteStatusDialog(response: any) {
    if (response) {
      if (response['ResponseCode'] === '200' && response['ResponseStatus'] && response['ResponseStatus'].toUpperCase() === 'SUCCESS') {
        this.openSaveUserDialog('Contact deleted successfully', null, true,'contact-delete-success');
      } else if (response['ResponseStatus'] && response['ResponseStatus'].toUpperCase() === 'ERROR') {
        this.openSaveUserDialog('Failed to delete contact', (response['Description'] ? response['Description'] : null), false,'contact-delete-fail');
      } else {
        this.openSaveUserDialog('Failed to delete contact', null, false,'contact-delete-fail');
      }
    } else {
      this.openSaveUserDialog('Failed to delete contact', null, false,'contact-delete-fail');
    }
  }



  save() {
    this.submitted = true;

    if (!this.addUserForm.valid) {
      this.openSaveUserDialog('There are items that require your attention', 'Please complete all fields marked with *', false,'contact-delete-message');
      return false;
    }
    
    this.addUserForm.controls['UpdatedBy'].setValue(this.loggedInUserName);
    this.addUserForm.controls['CreatedBy'].setValue(this.loggedInUserName);
    this.addUserForm.controls['UpdatedOn'].setValue(this.sharedService.getCurrentDateTime().toISOString());
    this.addUserForm.controls['CreatedOn'].setValue(this.sharedService.getCurrentDateTime().toISOString());

    if (this.addUserForm.value["PrimaryContactCountryCode"] === 'FIN') {
      this.phoneNumberWithCountryCode = '+358';
    } else if (this.addUserForm.value["PrimaryContactCountryCode"] === 'SWE') {
      this.phoneNumberWithCountryCode = '+46';
    } else if (this.addUserForm.value["PrimaryContactCountryCode"] === 'NOR') {
      this.phoneNumberWithCountryCode = '+47';
    } else if (this.addUserForm.value["PrimaryContactCountryCode"] === 'EST') {
      this.phoneNumberWithCountryCode = '+372';
    } else if (this.addUserForm.value["PrimaryContactCountryCode"] === 'DNK') {
      this.phoneNumberWithCountryCode = '+45';
    } else if (this.addUserForm.value["PrimaryContactCountryCode"] === 'GBR') {
      this.phoneNumberWithCountryCode = '+44';
    }
    this.phoneNumberWithCountryCode += this.addUserForm.value['Phone_Number'];

    // Commented below code, kept for future reference, save phone along with coutnry code
    // this.addUserForm.controls['Phone_Number'].setValue(this.phoneNumberWithCountryCode);
    
    // Check if valid image is selected for Photo, otherwise set it as null since service throws error if Photo is blank or if Photo contains invalid character of CDATA
    if (this.addUserForm.value['Photo'] === '' || (this.addUserForm.value['Photo'] && this.addUserForm.value['Photo'].toUpperCase().includes('CDATA'))) {
      this.addUserForm.controls['Photo'].setValue(null);
    }

    this.contactUsAdminService.createContactUs(this.addUserForm.value)
      .subscribe(
        res => {
          this.saveStatusDialog(res);
          // this.openSaveUserDialog();
          this.getContactUs();
        });

    //this.addUserForm.reset()
    this.reset();



  }

  // cancelUserDetails() {
  //   //this.router.navigate(["/dashboard"]);
  //   //location.reload();
  //   //this.addUserForm.reset();

  // }




  selectRow(row) {

    /* console.log(row);
    (<HTMLInputElement>document.getElementById("Contact_Name")).value=row.Contact_Name;
    (<HTMLInputElement>document.getElementById("Designation")).value=row.Designation;
    (<HTMLInputElement>document.getElementById("Phone_Number")).value=row.Phone_Number;
    (<HTMLInputElement>document.getElementById("Email_Id")).value=row.Email_Id;
    (<HTMLInputElement>document.getElementById("Country_Code")).value=row.Country_Code; */

    this.addUserForm.patchValue(row);
    this.addUserForm.controls['Contact_ID'].setValue(row['Contact_ID']);

    this.addUserForm.controls['PrimaryContactCountryCode'].setValue(row['Country_Code']);

    // Commented below code, kept for future reference, save phone along with coutnry code
    /* var phoneNumberWithCountryCode = this.addUserForm.value['Phone_Number'];
 
    if (phoneNumberWithCountryCode.toString().startsWith('+358')) {
      this.addUserForm.controls['PrimaryContactCountryCode'].setValue('FIN');
      this.addUserForm.controls['Phone_Number'].setValue(this.addUserForm.value['Phone_Number'].replace('+358 ', ''));
    } else if (phoneNumberWithCountryCode.toString().startsWith('+46')) {
      this.addUserForm.controls['PrimaryContactCountryCode'].setValue('SWE');
      this.addUserForm.controls['Phone_Number'].setValue(this.addUserForm.value['Phone_Number'].replace('+46 ', ''));
    } else if (phoneNumberWithCountryCode.toString().startsWith('+47')) {
      this.addUserForm.controls['PrimaryContactCountryCode'].setValue('NOR');
      this.addUserForm.controls['Phone_Number'].setValue(this.addUserForm.value['Phone_Number'].replace('+47 ', ''));
    } else if (phoneNumberWithCountryCode.toString().startsWith('+372')) {
      this.addUserForm.controls['PrimaryContactCountryCode'].setValue('EST');
      this.addUserForm.controls['Phone_Number'].setValue(this.addUserForm.value['Phone_Number'].replace('+372 ', ''));
    } else if (phoneNumberWithCountryCode.toString().startsWith('+45')) {
      this.addUserForm.controls['PrimaryContactCountryCode'].setValue('DNK');
      this.addUserForm.controls['Phone_Number'].setValue(this.addUserForm.value['Phone_Number'].replace('+45 ', ''));
    } else if (phoneNumberWithCountryCode.toString().startsWith('+44')) {
      this.addUserForm.controls['PrimaryContactCountryCode'].setValue('GBR');
      this.addUserForm.controls['Phone_Number'].setValue(this.addUserForm.value['Phone_Number'].replace('+44 ', ''));
    } */

    let image = row['Contact_Image'];
    this.imageUrl = image ? ('data:image/png;base64,' + image) : ''; 

  }

  deleteContact(id: number) {

    this.showConfirmationPopUp(id, 'delete-contact-us-confirmation');

    //console.log(id);
    /* if (confirm('Are you sure to delete?')) {
      this.contactUsAdminService.deleteContactUs(id).subscribe(res => {
        this.deleteStatusDialog(res);
        this.getContactUs();
      });
    } */
  }

  showConfirmationPopUp(id: number, headerNumber:string) {
		const dialogData = new ConfirmDialogModel("Delete contact us", '', '','',null);
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			// maxWidth: "410px",
			// data: dialogData,
			data: {
				headerNumber:headerNumber ,
				messageNumber: '',
				count: null
			},
			height: '37%',
			width: (this.mobileQuery.matches ? '60%' : '24%'),
			// header: 'Delete user group',
			
		});
		dialogRef.afterClosed().subscribe(dialogResult => {
			if (dialogResult) {
				this.contactUsAdminService.deleteContactUs(id).subscribe(res => {
          this.deleteStatusDialog(res);
          this.getContactUs();
        });
			}
		});
	}

  reset() {
    this.submitted = false;
    this.addUserForm.reset();
    this.presetFormValues();
    // this.addUserForm.controls['Country_Code'].setValue('Country');
    // this.addUserForm.controls['PrimaryContactCountryCode'].setValue('Country Code');
  }

  presetFormValues() {
    this.getCurrentMonthAndYear();
    this.addUserForm.controls['Contact_Name'].setValue('');
    this.imageUrl = 'data:image/png;base64,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';
    this.addUserForm.controls['Designation'].setValue('');
    this.addUserForm.controls['Phone_Number'].setValue('');
    this.addUserForm.controls['Email_Id'].setValue('');
    this.addUserForm.controls['Country_Code'].setValue('');
    this.addUserForm.controls['PrimaryContactCountryCode'].setValue('');
    this.addUserForm.controls['UpdatedBy'].setValue(this.loggedInUserName);
    this.addUserForm.controls['CreatedBy'].setValue(this.loggedInUserName);
    this.addUserForm.controls['UpdatedOn'].setValue(this.sharedService.getCurrentDateTime().toISOString());
    this.addUserForm.controls['CreatedOn'].setValue(this.sharedService.getCurrentDateTime().toISOString());
  }

  getCurrentMonthAndYear() {
    const date = this.sharedService.getCurrentDateTime();

    // Get current year
    let currentYear = date.getUTCFullYear();

    // Get current month
    var dateArray = date.toISOString().split("-");
    var month_index = parseInt(dateArray[1], 10) - 1;

    this.getYearList(currentYear);
    // this.priceIndexForm.controls['Month'].setValue(this.monthList[month_index]);
    // this.priceIndexForm.controls['Year'].setValue(currentYear);
  }

  getYearList(currYear: number) {
    this.yearList = [];
    this.yearList.push(currYear - 5, currYear - 4, currYear - 3, currYear - 2, currYear - 1, currYear, currYear + 1, currYear + 2, currYear + 3, currYear + 4, currYear + 5);
  }

}